var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "currentColor",
    "aria-hidden": "true"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.99 3.75a3.75 3.75 0 00-3.37 1.67.75.75 0 01-1.24 0A3.83 3.83 0 008 3.75 5.33 5.33 0 002.75 9c0 3.18 2.05 5.99 4.38 8.07a20.92 20.92 0 003.27 2.4 11.9 11.9 0 001.6.77l.05-.01.36-.14c.31-.14.72-.35 1.2-.63.94-.55 2.12-1.37 3.26-2.4C19.2 15 21.25 12.19 21.25 9a5.36 5.36 0 00-5.26-5.25zm-4 .06a5.34 5.34 0 014.02-1.56c3.36.05 6.74 2.79 6.74 6.75 0 3.82-2.45 7.01-4.87 9.18a22.42 22.42 0 01-3.52 2.58 13.4 13.4 0 01-1.86.9c-.13.04-.32.09-.5.09s-.37-.05-.5-.1a13.4 13.4 0 01-1.86-.9 22.42 22.42 0 01-3.52-2.57C3.7 16.01 1.25 12.82 1.25 9A6.83 6.83 0 018 2.25c1.38 0 2.86.4 4 1.56z"
  })));
}
export default SvgHeart;